<template>
    <footer class="bg-gray-900 text-white py-20 px-6 text-center">
      <h2 class="text-4xl font-black mb-6 tracking-tight">準備好讓生意變輕鬆了嗎？</h2>
      <p class="text-gray-400 mb-10 font-medium">不需要專業工程師，3 分鐘開通，立即營業。</p>
      <section class="py-24 px-6 max-w-4xl mx-auto">
    </section>
      <div class="mt-16 pt-8 border-t border-gray-700 text-gray-700 text-xs font-bold uppercase tracking-[0.2em]">
        © 稻香村 版權所有
      </div>
    </footer>
</template>
<script setup lang="ts">

import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

onMounted(() => {
  // 這裡可以放判斷邏輯，例如檢查是否有 QR code
  const qrId = '07d974e7-7973-476c-9bac-b711c170bce5'; 
  router.push(`/menu_order/${qrId}`);
});
</script>